import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center px-4">
      <Card className="max-w-md w-full">
        <CardContent className="pt-6">
          <div className="text-center space-y-6">
            <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
              <XCircle className="w-10 h-10 text-gray-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold mb-2">Payment Cancelled</h1>
              <p className="text-gray-600">
                Your payment was cancelled. No charges were made to your account.
              </p>
            </div>
            <div className="space-y-2">
              <Button
                onClick={() => navigate('/subscribe')}
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600"
              >
                Try Again
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/')}
                className="w-full"
              >
                Back to Dashboard
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
